// frontend/src/presentation/components/NetworkSyncStatusBar.tsx
//
// Globalny pasek stanu sieci / synchronizacji — warstwa prezentacji.
// Konsumuje współdzielony kontekst `useNetworkSyncContext` (jedna instancja
// Silnika Synchronizacji na całą aplikację — `NetworkSyncProvider`) i renderuje:
//  - czerwony pasek, gdy brak połączenia (praca w trybie offline),
//  - niebieski pasek, gdy trwa opróżnianie kolejki synchronizacji,
//  - `null` w stanie spoczynku (online i brak synchronizacji) — pasek ukryty.
//
// UWAGA: to ODRĘBNY komponent od demowego `src/components/SyncStatusBar.tsx`.
// Tamten jest zasilany propsami z kolejki dema i renderowany wewnątrz `Screen1`
// (dolny pasek). Tego pliku celowo NIE dotykamy — nowy pasek działa równolegle,
// globalnie, jako `position: fixed` nad całym UI, bez wpływu na layout ekranów.

import { useNetworkSyncContext } from '../context/networkSync'

// Stany paska. `bg` dublujemy inline jako bezpiecznik — komunikat o braku sieci
// musi być widoczny nawet gdyby dana klasa Tailwind nie trafiła do buildu.
const OFFLINE = {
  text: 'Brak połączenia – praca w trybie offline',
  className: 'bg-red-600 text-white',
  bg: '#dc2626',
} as const

const SYNCING = {
  text: 'Synchronizacja danych...',
  className: 'bg-blue-500 text-white',
  bg: '#3b82f6',
} as const

export function NetworkSyncStatusBar() {
  const { isOnline, isSyncing } = useNetworkSyncContext()

  const state = !isOnline ? OFFLINE : isSyncing ? SYNCING : null
  if (!state) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className={
        `${state.className} fixed left-1/2 top-0 z-[9990] w-full max-w-[450px] ` +
        '-translate-x-1/2 select-none px-4 py-1.5 text-center text-[12px] ' +
        'font-semibold tracking-wide shadow-md'
      }
      style={{
        // Bezpiecznik: krytyczne reguły niezależnie od wygenerowanych utilities.
        // z-index 9990 celowo poniżej splasha (9999), ekranu blokady (10000)
        // i osłony prywatności przełącznika aplikacji (99999).
        position: 'fixed',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9990,
        width: '100%',
        maxWidth: 450,
        backgroundColor: state.bg,
      }}
    >
      {state.text}
    </div>
  )
}
